const theme = {
  colors: {
    crem: "#ECF0F1",
  },
};

export type Theme = typeof theme;

export default theme;
